import { Component, Input } from '@angular/core';
import { combineLatest, defer, map, of, switchMap } from 'rxjs';

import {
  DisplayDeprecatedComponent,
  FormFacade,
  MessagingService,
  Qualification,
  QualificationFacade,
  QualificationService,
  UntilDestroy,
} from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-qualification-actions',
  templateUrl: 'chat-qualification-actions.component.html',
  styleUrls: ['./chat-qualification-actions.component.scss'],
})
export class ChatQualificationActionsComponent extends DisplayDeprecatedComponent {
  @Input()
  private responseId: string;

  readonly responseId$ = defer(() => of(this.responseId));
  readonly qualification$ = this.responseId$.pipe(switchMap(id => this.qualificationFacade.getById(id)));
  readonly qualificationValid$ = this.responseId$.pipe(switchMap(id => this.formFacade.isValid(QualificationService.toFormId(id))));
  readonly canRenewPostTreatment$ = this.qualification$.pipe(map(qualif => this._canRenewPostTreatment(qualif)));
  readonly canFinishQualification$ = combineLatest([this.qualification$, this.qualificationValid$]).pipe(
    map(([qualif, valid]) => this._canFinishQualification(qualif, valid))
  );

  constructor(
    protected readonly messaging: MessagingService,
    private readonly qualificationFacade: QualificationFacade,
    private readonly formFacade: FormFacade
  ) {
    super();
  }

  finishQualification(): void {
    this.qualificationFacade.stop(this.responseId);
  }

  renewPostTreatment(): void {
    this.qualificationFacade.renew(this.responseId);
  }

  private _canRenewPostTreatment(qualif: Qualification | undefined): boolean {
    return !!qualif && qualif.nbRenewable > 0 && qualif.renewableDuration > 0;
  }

  private _canFinishQualification(qualif: Qualification | undefined, valid: boolean): boolean {
    return !!qualif && qualif.canInterrupt && valid;
  }
}
